import { NavAreas } from '../vessel-nav-areas-model';

export const NavAreasGeometry : NavAreas = {
    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -35,
                75
              ],
              [
                -5,
                75
              ],
              [
                -5,
                65
              ],
              [
                10.8203056,
                65
              ],
              [
                29.5166667,
                67.4833333
              ],
              [
                37,
                57.9996667
              ],
              [
                4.5,
                48.45
              ],
              [
                -35,
                48.45
              ],
              [
                -35,
                75
              ]
            ]
          ]
        },
        "properties": {
          "id": "I",
          "name": "NAVAREA I",
          "coordinator": "United Kingdom"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                11.1166667,
                59
              ],
              [
                21,
                66
              ],
              [
                26.5,
                66.5
              ],
              [
                32,
                64
              ],
              [
                32,
                57
              ],
              [
                18,
                53
              ],
              [
                11,
                53
              ],
              [
                9,
                55
              ],
              [
                10.6333333,
                57.75
              ],
              [
                10.6333333,
                58.8833333
              ],
              [
                11.1166667,
                59
              ]
            ]
          ]
        },
        "properties": {
          "id": "IB",
          "name": "NAVAREA I - Baltic Sea sub-area",
          "coordinator": "Sweden"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -35,
                48.45
              ],
              [
                4.5,
                48.45
              ],
              [
                -5.75,
                36.0715833
              ],
              [
                -5.75,
                35.8178056
              ],
              [
                12.3945,
                0
              ],
              [
                12.3945,
                -6
              ],
              [
                -20,
                -6
              ],
              [
                -20,
                7
              ],
              [
                -35,
                7
              ],
              [
                -35,
                48.45
              ]
            ]
          ]
        },
        "properties": {
          "id": "II",
          "name": "NAVAREA II",
          "coordinator": "France"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -5.75,
                36.0715833
              ],
              [
                4.5,
                48.45
              ],
              [
                37,
                57.9996667
              ],
              [
                55.6333333,
                48.4395
              ],
              [
                55.6333333,
                35.7166667
              ],
              [
                43,
                35.7166667
              ],
              [
                34.1666667,
                30.3166667
              ],
              [
                18.6516111,
                29.8061389
              ],
              [
                -4.7276111,
                34.0463333
              ],
              [
                -5.75,
                35.8178056
              ],
              [
                -5.75,
                36.0715833
              ]
            ]
          ]
        },
        "properties": {
          "id": "III",
          "name": "NAVAREA III",
          "coordinator": "Spain"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -81.4857222,
                67
              ],
              [
                -35,
                67
              ],
              [
                -35,
                7
              ],
              [
                -49.4666667,
                7
              ],
              [
                -51.5333333,
                4.4418333
              ],
              [
                -51.4666667,
                4.0133333
              ],
              [
                -76.3833333,
                6.8333333
              ],
              [
                -78.0166667,
                8.8666667
              ],
              [
                -79.35,
                9.2
              ],
              [
                -81.2166667,
                8.2166667
              ],
              [
                -83.6666667,
                9.6166667
              ],
              [
                -85.5333333,
                13.6166667
              ],
              [
                -95.95,
                17.4333333
              ],
              [
                -100.5333333,
                21.9166667
              ],
              [
                -94,
                67
              ],
              [
                -81.4857222,
                67
              ]
            ]
          ]
        },
        "properties": {
          "id": "IV",
          "name": "NAVAREA IV",
          "coordinator": "United States of America"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -19.9843056,
                -35.8837222
              ],
              [
                -50.1666667,
                -35.8333333
              ],
              [
                -53.3736389,
                -33.7429167
              ],
              [
                -57,
                -32.1666667
              ],
              [
                -51.4666667,
                4.0133333
              ],
              [
                -51.5333333,
                4.4418333
              ],
              [
                -49.4666667,
                7
              ],
              [
                -20,
                7
              ],
              [
                -19.9843056,
                -35.8837222
              ]
            ]
          ]
        },
        "properties": {
          "id": "V",
          "name": "NAVAREA V",
          "coordinator": "Brazil"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -67.2666667,
                -55.3285833
              ],
              [
                -68.5918611,
                -54.9140278
              ],
              [
                -71.4333333,
                -49.3333333
              ],
              [
                -66.6833333,
                -34.85
              ],
              [
                -57,
                -32.1666667
              ],
              [
                -53.3736389,
                -33.7429167
              ],
              [
                -50.1666667,
                -35.8333333
              ],
              [
                -20,
                -35.8333333
              ],
              [
                -20,
                -75.5
              ],
              [
                -20,
                -89
              ],
              [
                -67.2666667,
                -89
              ],
              [
                -67.2666667,
                -72.5
              ],
              [
                -67.2666667,
                -67.0294167
              ],
              [
                -67.2666667,
                -55.3285833
              ]
            ]
          ]
        },
        "properties": {
          "id": "VI",
          "name": "NAVAREA VI",
          "coordinator": "Argentina"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -20,
                -6
              ],
              [
                12.3945,
                -6
              ],
              [
                40.5436944,
                -10.5
              ],
              [
                55,
                -10.5
              ],
              [
                55,
                -30
              ],
              [
                80,
                -30
              ],
              [
                80,
                -70
              ],
              [
                80,
                -89
              ],
              [
                -20,
                -89
              ],
              [
                -20,
                -6
              ]
            ]
          ]
        },
        "properties": {
          "id": "VII",
          "name": "NAVAREA VII",
          "coordinator": "Republic of South Africa"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                50.75,
                12
              ],
              [
                63,
                12
              ],
              [
                68.0833333,
                23.8
              ],
              [
                69.5019722,
                26.8194444
              ],
              [
                99.7,
                23.8
              ],
              [
                98.7833333,
                9.75
              ],
              [
                98.7833333,
                7.75
              ],
              [
                95,
                6
              ],
              [
                95,
                -30
              ],
              [
                55,
                -30
              ],
              [
                55,
                -10.5
              ],
              [
                40.5436944,
                -10.5
              ],
              [
                30.7871389,
                -8.9463333
              ],
              [
                50.75,
                12
              ]
            ]
          ]
        },
        "properties": {
          "id": "VIII",
          "name": "NAVAREA VIII",
          "coordinator": "India"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                63,
                12
              ],
              [
                50.75,
                12
              ],
              [
                44.9738333,
                5.9730833
              ],
              [
                29.8764722,
                30.1746667
              ],
              [
                34.1666667,
                30.3166667
              ],
              [
                43,
                35.7166667
              ],
              [
                55.6333333,
                35.7166667
              ],
              [
                69.5019722,
                26.8194444
              ],
              [
                68.0833333,
                23.8
              ],
              [
                63,
                12
              ]
            ]
          ]
        },
        "properties": {
          "id": "IX",
          "name": "NAVAREA IX",
          "coordinator": "Pakistan"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                95,
                -12
              ],
              [
                127,
                -12
              ],
              [
                127,
                -10
              ],
              [
                141,
                -10
              ],
              [
                141,
                0
              ],
              [
                170,
                0
              ],
              [
                170,
                -29
              ],
              [
                160,
                -45
              ],
              [
                160,
                -89
              ],
              [
                80,
                -89
              ],
              [
                80,
                -30
              ],
              [
                95,
                -30
              ],
              [
                95,
                -12
              ]
            ]
          ]
        },
        "properties": {
          "id": "X",
          "name": "NAVAREA X",
          "coordinator": "Australia"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                130.6916667,
                42.2916667
              ],
              [
                135,
                42.2916667
              ],
              [
                138.3333333,
                45
              ],
              [
                180,
                45
              ],
              [
                180,
                0
              ],
              [
                141,
                0
              ],
              [
                141,
                -10
              ],
              [
                127,
                -10
              ],
              [
                127,
                -12
              ],
              [
                95,
                -12
              ],
              [
                95,
                6
              ],
              [
                98.7833333,
                7.75
              ],
              [
                98.7833333,
                9.75
              ],
              [
                99.7,
                23.8
              ],
              [
                120.3833333,
                42.2916667
              ],
              [
                130.6916667,
                42.2916667
              ]
            ]
          ]
        },
        "properties": {
          "id": "XI",
          "name": "NAVAREA XI",
          "coordinator": "Japan"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -162.8771667,
                  67
                ],
                [
                  -162.9674444,
                  67.0243333
                ],
                [
                  -163.1,
                  67.0666667
                ],
                [
                  -161.1833333,
                  67.0666667
                ],
                [
                  -127.6,
                  62.6333333
                ],
                [
                  -100.5333333,
                  21.9166667
                ],
                [
                  -95.95,
                  17.4333333
                ],
                [
                  -85.5333333,
                  13.6166667
                ],
                [
                  -83.6666667,
                  9.6166667
                ],
                [
                  -81.2166667,
                  8.2166667
                ],
                [
                  -79.35,
                  9.2
                ],
                [
                  -78.0166667,
                  8.8666667
                ],
                [
                  -76.3833333,
                  6.8333333
                ],
                [
                  -76.3833333,
                  -3.4
                ],
                [
                  -80.3096944,
                  -3.4
                ],
                [
                  -120,
                  -3.4
                ],
                [
                  -120,
                  0
                ],
                [
                  -180,
                  0
                ],
                [
                  -180,
                  50
                ],
                [
                  -180,
                  57.688
                ],
                [
                  -177.4828889,
                  59.1556944
                ],
                [
                  -175.08825,
                  60.6257778
                ],
                [
                  -173.5371944,
                  61.6615278
                ],
                [
                  -170.9288056,
                  63.4923611
                ],
                [
                  -168.1084167,
                  65.6643889
                ],
                [
                  -166.5333333,
                  67
                ],
                [
                  -162.8771667,
                  67
                ]
              ],
              [
                [
                  170,
                  53
                ],
                [
                  176.3541389,
                  55.8095278
                ],
                [
                  179.4495,
                  57.4038056
                ],
                [
                  180,
                  57.688
                ],
                [
                  180,
                  50
                ],
                [
                  170,
                  53
                ]
              ]
            ]
          ]
        },
        "properties": {
          "id": "XII",
          "name": "NAVAREA XII",
          "coordinator": "United States of America"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -172.4986389,
                67
              ],
              [
                -168.9666667,
                67
              ],
              [
                -166.5333333,
                67.0009167
              ],
              [
                -168.1084167,
                65.6643889
              ],
              [
                -170.9288056,
                63.4923611
              ],
              [
                -173.5371944,
                61.6615278
              ],
              [
                -175.08825,
                60.6257778
              ],
              [
                -177.4812222,
                59.1556944
              ],
              [
                -180,
                57.688
              ],
              [
                -180,
                67
              ],
              [
                -176,
                67
              ],
              [
                -174.3166667,
                65.3333333
              ],
              [
                -172.4986389,
                67
              ]
            ],
            [
              [
                180,
                57.688
              ],
              [
                179.4495,
                57.4038056
              ],
              [
                176.3541389,
                55.8095278
              ],
              [
                170,
                53
              ],
              [
                180,
                50
              ],
              [
                180,
                48
              ],
              [
                180,
                45
              ],
              [
                138.3333333,
                45
              ],
              [
                135,
                42.2916667
              ],
              [
                130.6916667,
                42.2916667
              ],
              [
                130.6916667,
                67
              ],
              [
                180,
                67
              ],
              [
                180,
                57.688
              ]
            ]
          ]
        },
        "properties": {
          "id": "XIII",
          "name": "NAVAREA XIII",
          "coordinator": "Russian Federation"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  170,
                  0
                ],
                [
                  180,
                  0
                ],
                [
                  180,
                  -89
                ],
                [
                  160,
                  -89
                ],
                [
                  160,
                  -69.7145833
                ],
                [
                  160,
                  -45
                ],
                [
                  170,
                  -29
                ],
                [
                  170,
                  0
                ]
              ],
              [
                [
                  -120,
                  0
                ],
                [
                  -120,
                  -89
                ],
                [
                  -180,
                  -89
                ],
                [
                  -180,
                  0
                ],
                [
                  -120,
                  0
                ]
              ]
            ]
          ]
        },
        "properties": {
          "id": "XIV",
          "name": "NAVAREA XIV",
          "coordinator": "New Zealand"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -120,
                -18.35
              ],
              [
                -70.3779167,
                -18.35
              ],
              [
                -66.6833333,
                -18.35
              ],
              [
                -66.6833333,
                -34.85
              ],
              [
                -71.4333333,
                -49.3333333
              ],
              [
                -68.5918611,
                -54.9140278
              ],
              [
                -67.2666667,
                -55.3285833
              ],
              [
                -67.2666667,
                -67.0294167
              ],
              [
                -67.2666667,
                -89
              ],
              [
                -120,
                -89
              ],
              [
                -120,
                -73.8333333
              ],
              [
                -120,
                -18.35
              ]
            ]
          ]
        },
        "properties": {
          "id": "XV",
          "name": "NAVAREA XV",
          "coordinator": "Chile"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -120,
                -3.4
              ],
              [
                -76.3833333,
                -3.4
              ],
              [
                -66.6833333,
                -18.35
              ],
              [
                -120,
                -18.35
              ],
              [
                -120,
                -3.4
              ]
            ]
          ]
        },
        "properties": {
          "id": "XVI",
          "name": "NAVAREA XVI",
          "coordinator": "Peru"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -168.9666667,
                89
              ],
              [
                -120,
                89
              ],
              [
                -120,
                67
              ],
              [
                -160.6456111,
                67
              ],
              [
                -161.1833333,
                67.0666667
              ],
              [
                -163.1,
                67.0666667
              ],
              [
                -162.9674444,
                67.0243333
              ],
              [
                -162.8771667,
                67
              ],
              [
                -166.5333333,
                67
              ],
              [
                -168.9666667,
                67
              ],
              [
                -168.9666667,
                89
              ]
            ]
          ]
        },
        "properties": {
          "id": "XVII",
          "name": "NAVAREA XVII",
          "coordinator": "Canada"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -120,
                89
              ],
              [
                -35,
                89
              ],
              [
                -35,
                67
              ],
              [
                -53.7939167,
                67
              ],
              [
                -81.5,
                67
              ],
              [
                -120,
                67
              ],
              [
                -120,
                89
              ]
            ]
          ]
        },
        "properties": {
          "id": "XVIII",
          "name": "NAVAREA XVIII",
          "coordinator": "Canada"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -35,
                89
              ],
              [
                30,
                89
              ],
              [
                30,
                71
              ],
              [
                31.7166667,
                70.3666667
              ],
              [
                30.8193333,
                69.7946667
              ],
              [
                29.5166667,
                67.4833333
              ],
              [
                10.8203056,
                65
              ],
              [
                -5,
                65
              ],
              [
                -5,
                75
              ],
              [
                -35,
                75
              ],
              [
                -35,
                89
              ]
            ]
          ]
        },
        "properties": {
          "id": "XIX",
          "name": "NAVAREA XIX",
          "coordinator": "Norway"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                30,
                89
              ],
              [
                125,
                89
              ],
              [
                125,
                73.6528056
              ],
              [
                125,
                67
              ],
              [
                98.3166667,
                67
              ],
              [
                37,
                58
              ],
              [
                29.5166667,
                67.4833333
              ],
              [
                30.8193333,
                69.7946667
              ],
              [
                31.7166667,
                70.3666667
              ],
              [
                30,
                71
              ],
              [
                30,
                89
              ]
            ]
          ]
        },
        "properties": {
          "id": "XX",
          "name": "NAVAREA XX",
          "coordinator": "Russian Federation"
        }
      },
      {
        "type": "Feature",
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -180,
                  89
                ],
                [
                  -168.9666667,
                  89
                ],
                [
                  -168.9666667,
                  67
                ],
                [
                  -172.4986389,
                  67
                ],
                [
                  -174.3166667,
                  65.3333333
                ],
                [
                  -176,
                  67
                ],
                [
                  -180,
                  67
                ],
                [
                  -180,
                  89
                ]
              ],
              [
                [
                  125,
                  89
                ],
                [
                  180,
                  89
                ],
                [
                  180,
                  67
                ],
                [
                  125,
                  67
                ],
                [
                  125,
                  89
                ]
              ]
            ]
          ]
        },
        "properties": {
          "id": "XXI",
          "name": "NAVAREA XXI",
          "coordinator": "Russian Federation"
        }
      }
    ]
  };